import { useVerticalSignPole } from "../../hooks/queries/verticalSigning/useVerticalSignPoles"

import * as Styled from "./VerticalSignPoleDocumentList.styled"

export const VerticalSignPoleDocumentList = (props) => {
    const { poleId } = props

    const { data } = useVerticalSignPole(poleId)

    return <Styled.List documents={data?.documents} />
}